import React from "react";

const TestForm = ({ form, onChange, onSubmit, isTest, handleCheckClick }) => {
  return (
    <div>
      <form onSubmit={onSubmit}>
        <div>
          <label htmlFor="t_type">t_type:</label>
          <select
            id="t_type"
            name="t_type"
            onChange={onChange}
            value={form.t_type}
          >
            <option value="test">test(테스트용)</option>
            <option value="non-mem">non-mem(비회원)</option>
            <option value="assoc-mem">assoc-mem(준회원)</option>
            <option value="reg-mem">reg-mem(정회원)</option>
          </select>
        </div>
        <div>
          <label htmlFor="diag_t_id">diag_t_id:</label>
          <input
            id="diag_t_id"
            type="text"
            name="diag_t_id"
            placeholder="diag_t_id"
            onChange={onChange}
            value={form.diag_t_id}
          />
        </div>
        <div>
          <label htmlFor="name">name:</label>
          <input
            id="name"
            type="text"
            name="name"
            placeholder="name"
            onChange={onChange}
            value={form.name}
          />
        </div>
        <div>
          <label htmlFor="grade">grade:</label>
          <select id="grade" name="grade" onChange={onChange} value={form.grade}>
            <option value="01">초등 1학년</option>
            <option value="02">초등 2학년</option>
            <option value="03">초등 3학년</option>
            <option value="04">초등 4학년</option>
            <option value="05">초등 5학년</option>
            <option value="06">초등 6학년</option>
            <option value="07">중등 1학년</option>
            <option value="08">중등 2학년</option>
            <option value="09">중등 3학년</option>
          </select>
        </div>
        <div>
          <label htmlFor="st_month">month:</label>
          <select
            id="st_month"
            name="st_month"
            onChange={onChange}
            value={form.st_month}
          >
            <option value="">없음</option>
            <option value="1">1월</option>
            <option value="2">2월</option>
            <option value="3">3월</option>
            <option value="4">4월</option>
            <option value="5">5월</option>
            <option value="6">6월</option>
            <option value="7">7월</option>
            <option value="8">8월</option>
            <option value="9">9월</option>
            <option value="10">10월</option>
            <option value="11">11월</option>
            <option value="12">12월</option>
          </select>
          <div>
            <label htmlFor="apiTest"><b>API Test Mode:</b> </label>
            <input type="checkbox" defaultChecked={isTest} onClick={() => handleCheckClick()} />
          </div>
        </div>
        <button>제출</button>
      </form>
    </div>
  );
};

export default TestForm;
